export default {"src":"/_next/static/media/shipment-details.7a2b7d09.svg","height":48,"width":48};